var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h2',[_vm._v("js-tools")]),_c('div',{staticClass:"row mt-3"},[_c('b-input',{attrs:{"placeholder":"input something...."},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_vm._v(" "+_vm._s(_vm.createEncode(_vm.value))+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }